import { COUNTRY_META } from "../../lib/constants.ts";

interface CountryBadgeProps {
  code: keyof typeof COUNTRY_META;
  showName?: boolean;
}

export function CountryBadge({ code, showName = false }: CountryBadgeProps) {
  const meta = COUNTRY_META[code];
  if (!meta) return null;

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[13px] font-medium ${meta.badgeBg} ${meta.badgeText}`}>
      <span>{meta.flag}</span>
      <span>{showName ? meta.name : code}</span>
    </span>
  );
}
